var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9625 9.26142L3.24058 0.200447C3.00888 0.0678157 2.74654 -0.0011377 2.47995 0.000517389C2.21335 0.00217247 1.95188 0.0743778 1.72183 0.209875C1.49642 0.340761 1.30928 0.529071 1.17926 0.755841C1.04924 0.982611 0.980925 1.23983 0.981202 1.50161V19.6235C0.983678 20.022 1.14281 20.4033 1.42384 20.6842C1.70488 20.9651 2.085 21.1227 2.4812 21.1227C2.74683 21.1218 3.00796 21.0537 3.24058 20.9247L18.9625 11.8637C19.1954 11.7366 19.3899 11.5487 19.5254 11.3197C19.6609 11.0906 19.7325 10.8291 19.7325 10.5626C19.7325 10.2961 19.6609 10.0345 19.5254 9.80549C19.3899 9.57647 19.1954 9.3885 18.9625 9.26142ZM11.5 11.628L13.2718 13.41L5.00308 18.1621L11.5 11.628ZM5.00308 2.95362L13.2718 7.71511L11.5 9.49713L5.00308 2.95362ZM14.6125 12.6275L12.5593 10.5626L14.6125 8.49769L18.2125 10.5626L14.6125 12.6275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.3da9755165e6fb740b0300c30d75e5f8.svg";
export { ForwardRef as ReactComponent };